import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhoneNew = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 64,
			height: 64,
			rx: 32,
			fill: "#CCE4FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M42.6356 43.9947L44.8661 41.7407C45.4821 41.1185 45.8348 40.2454 45.8348 39.3441C45.8348 38.446 45.4836 37.5729 44.8676 36.9491L41.0384 33.0744C40.402 32.4317 39.5525 32.0791 38.6496 32.0791C37.7468 32.0791 36.8972 32.4333 36.2577 33.0775L34.568 34.7892C34.1338 34.6512 33.2216 34.2045 31.7905 32.7546C30.2921 31.2389 29.8704 30.3032 29.7403 29.9301L31.4692 28.1808C32.6981 26.9379 32.6949 24.6306 31.4692 23.3939L27.6447 19.5255C27.0067 18.8781 26.1572 18.5207 25.2512 18.5207C24.3436 18.5207 23.4925 18.8781 22.8608 19.5223L20.6288 21.781C19.6868 22.734 19.168 24.2419 19.168 26.0335C19.168 27.8846 19.8075 32.8361 25.7324 38.8316C29.7952 42.9414 33.336 44.5057 35.5884 45.0935C38.5556 45.8694 41.1889 45.4603 42.6356 43.9947ZM43.0132 39.3441C43.0132 39.5083 42.9493 39.6664 42.8605 39.7562L40.63 42.0101C39.9905 42.658 38.384 42.9082 36.302 42.3638C33.7642 41.7016 30.8589 40.0043 27.7387 36.848C23.5016 32.5604 21.9892 28.8342 21.9892 26.0334C21.9892 24.9357 22.262 24.142 22.6352 23.7644L24.8675 21.5054C24.9763 21.3945 25.1014 21.3421 25.251 21.3421C25.3996 21.3421 25.5259 21.3951 25.635 21.5058L29.4627 25.3775C29.6028 25.5188 29.603 26.0553 29.4627 26.1972L27.7335 27.9468L26.4969 29.198L27.0762 30.8591C27.462 31.9655 28.2937 33.2307 29.784 34.7382C31.2675 36.2411 32.5635 37.1127 33.7136 37.4781L35.3612 38.0015L38.2654 35.0596C38.37 34.9542 38.499 34.9004 38.6495 34.9004C38.8011 34.9004 38.9283 34.9533 39.0335 35.0596L42.8607 38.9323C42.9492 39.0218 43.0132 39.1806 43.0132 39.3441Z",
			fill: "#005AA0"
		})
	]
});
const ForwardRef = forwardRef(SvgPhoneNew);
export { ForwardRef as ReactComponent };
